import interceptors from "./interceptors/index";

const saveSkirts = (items) => {
  return interceptors({
    url: "/documents/menu",
    method: "POST",
    data: { items },
  });
};

const fetchSkirts = () => {
  return interceptors({
    url: "/documents/menu",
    method: "GET",
  });
};

export { saveSkirts, fetchSkirts };
